import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

function TooltipQARequirements({ children, content }) {
    const [visible, setVisible] = useState(false);
    const [pos, setPos] = useState({ top: 0, left: 0 });

    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);
    const hideTimer = useRef(null);

    const updatePosition = () => {
        const rect = triggerRef.current.getBoundingClientRect();
        setPos({
            top: rect.top + window.scrollY - 8,
            left: rect.left + window.scrollX,
        });
    };

    // --- Show / hide with delay ---
    const showTooltip = () => {
        clearTimeout(hideTimer.current);
        updatePosition();
        setVisible(true);
    };

    const hideTooltip = () => {
        hideTimer.current = setTimeout(() => {
                    setVisible(false);
        }, 150); // delay prevents flicker
    };

    useEffect(() => {
        return () => clearTimeout(hideTimer.current);
    }, []);

    // Reposition on scroll/resize 
    useEffect(() => {
        if (!visible) return;

        const handleUpdate = () => updatePosition();

        window.addEventListener("scroll", handleUpdate, true);
        window.addEventListener("resize", handleUpdate);

        return () => {
            window.removeEventListener("scroll", handleUpdate, true);
            window.removeEventListener("resize", handleUpdate);
        };
    }, [visible]);

    return (
        <>
            <span
                ref={triggerRef}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
                style={{ display: "inline-block" }}
            >
                {children}
            </span>

        {visible &&
            createPortal(
                <div
                    ref={tooltipRef}
                    onMouseEnter={showTooltip}           
                    onMouseLeave={hideTooltip}  
                    style={{
                        position: "absolute",
                        top: pos.top,
                        left: pos.left,
                        transform: "translateY(-100%)",
                        width: 220,
                        background: "#1e1e1e",
                        border: "0.5px solid rgba(255,255,255,0.14)",
                        borderRadius: 9,
                        padding: "11px 13px",
                        boxShadow: "0 4px 24px rgba(0,0,0,0.5)",
                        zIndex: 999999,
                        pointerEvents: "auto",
                    }}
                >
                    {content}
                </div>,
                document.body
            )}
        </>
    );
}

export default TooltipQARequirements;